var _defs, _rect, _polygon, _polygon2, _polygon3, _polygon4, _line, _polygon5, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _path, _path2, _path3, _polygon6, _path4, _path5, _path6, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpBlankIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e,.f,.j,.k{fill:none;}.b,.h{fill:#3c3c46;}.b,.c,.d,.e,.g,.h,.i,.j{fill-rule:evenodd;}.b{opacity:0.15;}.c{fill:#fff;}.d,.g{fill:#ffefe0;}.e,.f,.g,.i{stroke:#3c3c46;}.e,.f,.g,.i,.j,.k{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.i{fill:#89d9fb;}.j,.k{stroke:#e5e5e5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-blank-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "22.98 15.84 102.97 15.84 102.97 111.16 83.97 130.16 22.98 130.16 22.98 15.84"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "16.98 9.84 96.97 9.84 96.97 105.16 77.97 124.16 16.98 124.16 16.98 9.84"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "59.1 9.84 96.97 9.84 96.97 105.16 77.97 124.16 59.1 124.16 59.1 9.84"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "16.98 9.84 96.97 9.84 96.97 105.16 77.97 124.16 16.98 124.16 16.98 9.84"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 58.47,
    y1: 29.07,
    x2: 82.29,
    y2: 29.07
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "77.97 124.16 77.97 105.16 96.97 105.16 77.97 124.16"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 31.66,
    y1: 74.65,
    x2: 59.25,
    y2: 74.65
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 31.66,
    y1: 80.99,
    x2: 82.29,
    y2: 80.99
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 31.66,
    y1: 93.89,
    x2: 82.29,
    y2: 93.89
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 73.07,
    y1: 87.32,
    x2: 82.29,
    y2: 87.32
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 67.51,
    y1: 74.65,
    x2: 82.29,
    y2: 74.65
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 31.66,
    y1: 87.32,
    x2: 48.14,
    y2: 87.32
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 54.64,
    y1: 87.32,
    x2: 63.86,
    y2: 87.32
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 31.66,
    y1: 49.08,
    x2: 59.25,
    y2: 49.08
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 31.66,
    y1: 55.42,
    x2: 82.29,
    y2: 55.42
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 31.66,
    y1: 68.32,
    x2: 82.29,
    y2: 68.32
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 73.07,
    y1: 61.76,
    x2: 82.29,
    y2: 61.76
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 67.51,
    y1: 49.08,
    x2: 82.29,
    y2: 49.08
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 31.66,
    y1: 61.76,
    x2: 48.14,
    y2: 61.76
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 54.64,
    y1: 61.76,
    x2: 63.86,
    y2: 61.76
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M45,109.32a.82.82,0,0,1-.78-1.08,2.26,2.26,0,0,0,.1-.56,3.43,3.43,0,0,1-2,1.59,2.2,2.2,0,0,1-2.18-.82c-1.36-1.5-.43-3.18.24-4.41.8-1.45.77-1.68.34-2a1.64,1.64,0,0,0-1.31.07c-2.62,1-6.2,4.94-6.5,6a.82.82,0,1,1-1.58-.46c.49-1.68,4.54-6,7.51-7.05a3,3,0,0,1,2.78.09,2.08,2.08,0,0,1,1,2.19,6.4,6.4,0,0,1-.81,1.93c-.93,1.7-.85,2.08-.47,2.51s.54.34.61.32c.49-.11,1.28-1.11,1.75-2.61a.82.82,0,0,1,1.49-.18,5.67,5.67,0,0,1,.6,1.52,12.67,12.67,0,0,0,.64-1.5.82.82,0,0,1,1.26-.38,4.11,4.11,0,0,1,1.7,2.65,2.4,2.4,0,0,1-.77,1.91.82.82,0,1,1-1.16-1.16.77.77,0,0,0,.29-.63,1.36,1.36,0,0,0-.26-.64,4.89,4.89,0,0,1-2.19,2.59A.82.82,0,0,1,45,109.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M34.2,111.65h0a.82.82,0,0,1-.78-.86c0-.92,1.39-2.62,1.66-3,.8-1,2-2.2,3.1-2.35a.82.82,0,1,1,.22,1.63,4.78,4.78,0,0,0-2,1.65A8.48,8.48,0,0,0,35,110.9.82.82,0,0,1,34.2,111.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M44.13,27.16,42.7,28.58a4,4,0,1,0,0,5.6l4.47,4.47a10.28,10.28,0,1,1,0-14.54Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "121.29 61.86 121.15 89.97 113.29 90.05 113.32 49.7 119.44 49.65 119.55 61.87 121.29 61.86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M121.06,37l0,4.8h0a1.75,1.75,0,0,0-1.72,1.75l.06,6.17h-6.12l-.11-12.47a4.08,4.08,0,0,1,4-4.15A3.94,3.94,0,0,1,121.06,37Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M122.87,43.52,123,61a.87.87,0,0,1-.86.88l-2.62,0-.15-18.36a1.75,1.75,0,0,1,1.72-1.75h0a1.75,1.75,0,0,1,1.76,1.73Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M113.29,90l3.53,10.29a.87.87,0,0,0,1.67-.07L121.14,90Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 119.5,
    y: 57.49,
    width: 3.49,
    height: 1.75,
    transform: "translate(-0.52 1.1) rotate(-0.52)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpBlankIcon);
export default __webpack_public_path__ + "static/media/CP-blank-icon.ff44bb94744333ea076a0192dffde42c.svg";
export { ForwardRef as ReactComponent };